var Festival = {
    lock: false,
    claimEnergy: false,
    claim: function(day_quest) {
        if (!Festival.lock) {
            Festival.lock = true;
            let container = document.getElementById('festival_quest');
            let inputData = document.getElementById('data_festival_input_to_check').value;
            Api.post('/festival/claim', {day: day_quest, answer: inputData}, function (i) {
                if (i.success) {
                    Alert.push([{
                        type: 'success',
                        text: 'El reto ha sido superado satisfactoriamente.',
                        icon: 'check'
                    }]);
                    container.remove();
                } else {
                    switch (i.error.identifier) {
                        case 'specific_requirements_not_completed':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! No cumples todos los requsitios para este reto.',
                                icon: 'triangle-alert'
                            }]);
                            break;
                        case 'energy_level_not_full':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! No tienes la energía suficiente para completar este reto.',
                                icon: 'triangle-alert'
                            }]);
                            break;
                        case 'task_not_available':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! Este reto no está disponible.',
                                icon: 'triangle-alert'
                            }]);
                            container.remove();
                            break;
                        case 'task_already_completed':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! Ya has completado este reto anteriormente.',
                                icon: 'triangle-alert'
                            }]);
                            container.remove();
                            break;
                        case 'task_not_found':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! No hemos encontrado este reto.',
                                icon: 'triangle-alert'
                            }]);
                            container.remove();
                            break;
                    }
                }
                Festival.lock = false;
            });
        }
    },

    energy: function(token_energy) {
        if (!Festival.claimEnergy) {
            Festival.claimEnergy = true;
            let container_box = document.getElementById(`etoken_${token_energy}`);
            let icon = document.getElementById(`etoken_flash_energy_${token_energy}`);
            Api.post('/festivalEnergy/catch', {token: token_energy}, function (i) {
                console.log(i);
                if (i.success) {
                    Alert.push([{
                        type: 'success',
                        text: 'Se ha sumado un 10% de energía a tu cuenta. Visita https://habtium.es/festival para usarla.',
                        icon: 'check'
                    }]);
                    container_box.remove();
                } else {
                    switch (i.error.identifier) {
                        case 'already_taken_by_other_user':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! Alguien más ha pillado esta energía.',
                                icon: 'triangle-alert'
                            }]);
                            container_box.remove();
                            break;
                        case 'energy_taken_by_another_user':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! Alguien más ha pillado esta energía.',
                                icon: 'triangle-alert'
                            }]);
                            container_box.remove();
                            break;
                        case 'full_energy_capacity':
                            Alert.push([{
                                type: 'danger',
                                text: '¡Oops! Tienes completas tus energías. No puedes obtener esta.',
                                icon: 'triangle-alert'
                            }]);
                            break;
                    }
                }
                Festival.claimEnergy = false;
            });
        }
    }
}
